// ------------------------------------
// props 輸入需求 :
// props.hide : function( void )                    ( 開關按鈕 )
// props.pageName : array                           ( 傳進來的分頁名字 )
// ------------------------------------

import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DropdownHis from './DropdownHis';
import { useDispatch, useSelector } from 'react-redux';
import ConfigHandler from '../../actions/ConfigHandler';
import { SET_PAGE } from '../../stores/reducer_HistoryPage';

const PopUpNavBar = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { page, dropDown, pageActive } = useSelector((state) => state.store_hisPage);
  const [dropDownToggle, setDropDownToggle] = useState([]);
  const [navConfig, setNavConfig] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const config = await ConfigHandler.hisRecControl();
        setNavConfig(config);
        setDropDownToggle(Array(config.pageNum).fill(false));
      } catch (error) {
        console.error("Error fetching:", error);
      }
    })();
  }, []);

  if (!navConfig) {
    return null;
  }
  const { layoutName: pageNameArr, dropDownList, layoutImg: pageIcon, pageNum } = navConfig;
  const toggleDropDown = (index) => {
    let _row = Array(pageNum).fill(false);
    if (!index) {
      setDropDownToggle(_row);
    }
    _row[index] = true;
    setDropDownToggle(_row);
  };



  return (
    <div className="h-15 fx-d-r font-m">
      <div className="w-40 fx-d-c fx-ccc">
        <div className="w-90 font-xl fx-fsc">{t(pageNameArr[page])}</div>
        <div className="w-90 font-ml fx-fsc">{t(dropDownList[page][dropDown])}</div>
      </div>
      {/* <div className='w-30'></div> */}
      {/* 填充空間用 */}
      {/* {props.isShow.map((isShow, index) => (isShow ? null : <div className="fx-2" key={index}></div>))} */}
      {/* 填充空間用 */}
      <div className='fx-nfen w-100'>
        {pageNameArr.map((name, index) =>
          name === '' ? (
            <div className="w-10" key={index}></div>
          ) : (
            <div
              key={name}
              className={`fx-ccc his-option pos-r ${pageActive[index] ? 'activate' : ''}  ${props.isShow[index] ? '' : 'd-none'}`}
              onClick={() => {
                dispatch(SET_PAGE(index));
              }}
              onMouseEnter={() => {
                toggleDropDown(index);
              }}
              onMouseLeave={() => {
                toggleDropDown(false);
              }}
            >
              <img className="img_crisp" src={pageIcon[index]} alt={pageNameArr[index]} />
              {t(name)}
              {
                dropDownToggle[index]
                  ? <DropdownHis hide={toggleDropDown} data={{ keys: dropDownList[index], page: index }} />
                  : null
              }
            </div>
          )
        )}
        {/* close btn */}
        <div className="fx-2 fx-nfen his-btn" onClick={props.hide}>
          <div className="cross dark fx-ccc cursor pt"></div>
        </div>
        {/* close btn */}
      </div>
    </div>
  );
};
export default PopUpNavBar;
